// src/lib/quietConsole.js
// Mute verbose logs in production unless VITE_DEBUG=true
/* eslint-disable no-console -- this file intentionally modifies console methods for production quieting */
if (import.meta?.env?.PROD && import.meta?.env?.VITE_DEBUG !== 'true') {
  const noop = () => {};
  // keep warn/error for real issues
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}
/* eslint-enable no-console */
export {};
